import { sendLog } from '@src/lib/betterstack';

/**
 * Ship one structured line to Better Stack. No-ops when the source isn't
 * configured, so call sites need no guards.
 *
 * Pass `request_id` wherever one exists — it is what joins a browser line to
 * the backend line that served the same request.
 *
 * Never pass request or response bodies: this is a log stream, and Guardian
 * payloads carry account and participant data.
 *
 * Usage:
 *   logError('api_request_failed', { url, method, status, request_id })
 */
export function logInfo(message: string, context?: Record<string, unknown>): void {
    sendLog('info', message, context);
}

export function logWarn(message: string, context?: Record<string, unknown>): void {
    sendLog('warn', message, context);
}

export function logError(message: string, context?: Record<string, unknown>): void {
    sendLog('error', message, context);
}
